import '../../node_modules/owl.carousel'

/**
 * Plugin pour owl Carousel.
 * Il redéfinit la méthode "duration" qui calcul la vitesse de passage d'une étape à l'autre
 * cette vitesse est rendu constante pour éviter les transitions trop longue entre deux étapes non continue/
 *  ex: passage de l'étap 1 à l'étape 2 = 200ms
 *      passage de l'étape 1 à l'étape 5 = 200ms au lieu de 800ms ( 4* 200ms)
 * @since 2.0.0
 */
;(function ( $, window, document, undefined ) {
    var PluginOwlKinougarde = function(scope){
        this.owl = scope;    
        this.owl.duration = PluginOwlKinougarde.prototype.duration;
    }      

    /**
	 * Calculates the speed for a translation.
	 * @protected
	 * @param {Number} from - The absolute position of the start item.
	 * @param {Number} to - The absolute position of the target item.
	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
	 * @returns {Number} - The time in milliseconds for the translation.
	 */
	PluginOwlKinougarde.prototype.duration = function(from, to, factor) {
		if (factor === 0) {
			return 0;
		}        
		return Math.abs((factor || this.settings.smartSpeed));
	};
   
    $.fn.owlCarousel.Constructor.Plugins.PluginOwlKinougarde = PluginOwlKinougarde;
})( window.Zepto || window.jQuery, window,  document );